import React, { useState, useEffect } from 'react';
const CauseCard = props => {
  return (
    <div
        className="cause-card"
    >
        <p className="cause-item-title">{props.item.title}</p>
        <div
            style={{backgroundImage:`url(${props.item.image_url})`}}
            className="background"
        />
        <div className="card-content">
            <div>
                <i className="fa fa-map-marker-alt" />
                <p className="cause-item-text">{props.item.address.formatted_address}</p>
            </div>
           
           <p className="cause-item-Price">Price: {props.item.is_price_fixed?props.item.price:"Manual"}</p>
           <p className="cause-item-Token">{props.item.is_token_shopping?"Shopping Tokens: ":"Premier Tokens: "}{props.item.token}</p>
        </div>
        
    </div>
  );
};
export default CauseCard;


// WEBPACK FOOTER //
// ./src/screens/Cause/CauseCard.js